export default __webpack_public_path__ + "static/media/US.8f1bacdb.svg";